
import { reactive, ref, toRefs, unref, onMounted, defineComponent } from "vue";
//引入vue方法
import { ElConfigProvider } from "element-plus";
import type { ElForm } from "element-plus";
//中文包
import { useRouter } from "vue-router";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { getNwes, delNwes, getNewsInfo, putNwes } from "@/api/backstage";
import { ElMessage } from "element-plus";
import { getEnum } from "@/api/index";
type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  name: "新闻公告",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
  },
  setup() {
    let locale = zhCn;
    const router = useRouter();
    const dataMap: any = reactive({
      ruleFormRef: ref<FormInstance>(),
      newsType: {},
      drawer: false,
      newsInfo: "",
      status: {},
      tableData: [],
      total: 0,
      time: "",
      form: {
        keyword: "",
        newsType: "",
        isTop: "",
        status: "",
        pageNum: 1,
        pageSize: 10,
      },
      async getList() {
        const data = await getNwes(this.form);
        for (const item of data.data.list) {
          if (item.fileName) {
            item.fileUrl = localStorage.getItem("fileUrel") + item.fileName;
          }
          item.isTop === 0 ? (item.isTop = false) : (item.isTop = true);
        }
        dataMap.tableData = data?.data.list ?? [];
        dataMap.total = data?.data.total ?? 0;
      },
      async getNewsType() {
        dataMap.newsType = {};
        const menus = await getEnum("NEWS");
        for (const item of menus.data) {
          dataMap.newsType[item.enumKey] = item;
        }
      },
      async getStatus() {
        dataMap.status = {};
        const menus = await getEnum("STATUS");
        for (const item of menus.data) {
          dataMap.status[item.enumKey] = item;
        }
      },
      async delDataList(ids: any) {
        const baseId = { id: ids };
        const res = await delNwes(baseId);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          dataMap.getList();
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
      async putNwes(row: any) {
        let query: any = JSON.parse(JSON.stringify(row));
        query.isTop ? (query.isTop = 1) : (query.isTop = 0);
        const res = await putNwes(query);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          dataMap.getList();
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });
    const onSubmit = () => {
      dataMap.getList();
    };

    const resetForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.resetFields();
      dataMap.getList();
    };

    const handleSizeChange = (val: number) => {
      dataMap.form.pageSize = val;
      dataMap.getList();
    };
    const handleCurrentChange = (val: number) => {
      dataMap.form.pageNum = val;
      dataMap.getList();
    };

    const confirmEvent = (row: any, index: any) => {
      dataMap.delDataList(row.id);
    };
    const getDetail = (row: any) => {
      dataMap.drawer = true;
      getNewsInfo(row.id).then((res: any) => {
        dataMap.newsInfo = res?.data ?? "";
        dataMap.newsInfo.fileName
          ? (dataMap.newsInfo.fileUrl =
              localStorage.getItem("fileUrel") + dataMap.newsInfo.fileName)
          : "";
      });
    };
    onMounted(() => {
      dataMap.getList();
      dataMap.getNewsType();
      dataMap.getStatus();
    });

    return {
      locale,
      close,
      onSubmit,
      resetForm,
      getDetail,
      router,
      confirmEvent,
      handleSizeChange,
      handleCurrentChange,
      ...toRefs(dataMap),
    };
  },
});
